// Imperative confetti + toast feedback, ported from the design prototype.
// Both respect prefers-reduced-motion.

function reduceMotion() {
  try {
    return window.matchMedia("(prefers-reduced-motion: reduce)").matches;
  } catch (e) {
    return false;
  }
}

export function showToast(msg) {
  const t = document.createElement("div");
  t.textContent = msg;
  t.style.cssText =
    "position:fixed;left:50%;bottom:44px;transform:translate(-50%,0);" +
    "background:#15803d;color:#fff;font-family:inherit;font-weight:700;font-size:15px;" +
    "padding:12px 22px;border-radius:999px;box-shadow:0 8px 24px rgba(0,0,0,.18);z-index:10000;" +
    "animation:rtr-toast-in 260ms cubic-bezier(0.34,1.56,0.64,1);";
  document.body.appendChild(t);
  setTimeout(() => {
    t.style.transition = "opacity 300ms ease";
    t.style.opacity = "0";
    setTimeout(() => t.remove(), 320);
  }, 1800);
}

export function launchConfetti() {
  if (reduceMotion()) return;
  const colors = ["#16a34a", "#facc15", "#0c5285", "#f6f0e2", "#d97706"];
  const layer = document.createElement("div");
  layer.style.cssText =
    "position:fixed;inset:0;pointer-events:none;z-index:9999;overflow:hidden;";
  document.body.appendChild(layer);
  for (let i = 0; i < 90; i++) {
    const p = document.createElement("div");
    const size = 6 + Math.random() * 9;
    const dur = 1500 + Math.random() * 1300;
    const delay = Math.random() * 250;
    p.style.cssText =
      "position:absolute;top:-24px;left:" +
      Math.random() * 100 +
      "vw;width:" +
      size +
      "px;height:" +
      size * 0.55 +
      "px;background:" +
      colors[i % colors.length] +
      ";border-radius:2px;opacity:.95;animation:rtr-confetti " +
      dur +
      "ms " +
      delay +
      "ms cubic-bezier(.2,.6,.4,1) forwards;";
    p.style.setProperty("--drift", Math.random() * 240 - 120 + "px");
    p.style.setProperty("--rot", Math.random() * 900 - 450 + "deg");
    layer.appendChild(p);
  }
  setTimeout(() => layer.remove(), 3400);
}
